import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import { fetchDoctorDatasss, getCountry, getcountryname, getState, gethcountryname, UploadImageData, UploadHImageData } from '../reduxactions/suprivisoractions/SuprivisorProfileActions';
import useEffectOnce from '../hooks/useEffectOnce';
import { Panel } from 'primereact/panel';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { SUPRIVISOR_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { SelectButton } from 'primereact/selectbutton';
import { InputText } from 'primereact/inputtext';
import { Card } from 'primereact/card';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import './SuprivisorProfile.css';
import eventBus from '../doctorapprover/eventBus';
// import Form from 'react-bootstrap/Form';

export const SuprivisorProfile = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');
    const stepperRef = useRef(null);

    const [activeIndex, setActiveIndex] = useState(0);
    const options = ['Personal Info', 'Hospital Info'];
    const [value, setValue] = useState(options[0]);


    const dispatch = useDispatch();
    const data = useSelector((state: RootState) => state.sprofile.data);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [address, setAddress] = useState('');

    const [hospitalName, setHospitalname] = useState('');
    const [hospitalPrefix, setprefix] = useState('');
    const [hphone, sethphone] = useState('');
    const [hcountry, sethcountry] = useState('');
    const [hstate, sethstate] = useState('');
    const [hcity, sethcity] = useState('');
    const [haddress, sethaddress] = useState('');
    const [pincode, sethpin] = useState('');
    const [hsptl, sethsptl] = useState('');

    const [photo, setPhoto] = useState('');
    useEffect(() => {
        const profilephoto = data[0]?.photo;
        window.sessionStorage.setItem('photo', profilephoto);
        handlePhotoUpdate(profilephoto);
    }, [data]);

    const handlePhotoUpdate = (newPhoto: any) => {
        setPhoto(newPhoto);
        eventBus.emit('photoUpdated', newPhoto);
    };


    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchDoctorDatasss(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch]);
    const [selectedFile, setselectedFile] = useState<File | null>(null);
    const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
        const files = event.files;
        if (files.length > 0) {
            const file = files[0];
            console.log("file:", file);
            setselectedFile(file);
            console.log("called image function:", file)
            try {
                await dispatch(UploadImageData(file, uid) as any);
                fetchDataAsync();
                fetchDataAsync1();
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }

    };
    const [selectedFile1, setselectedFile1] = useState<File | null>(null);
    const UploadManagerHosImage = async (event: FileUploadHandlerEvent) => {
        const files = event.files;
        if (files.length > 0) {
            const file = files[0];
            console.log("file:", file);
            setselectedFile1(file);
            console.log("called image function:", file)
            try {
                await dispatch(UploadHImageData(file, uid) as any);
                fetchDataAsync();
                fetchDataAsync1();
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }

    };
    const [hospitalid, setHospitalID] = useState('');
    //To get data
    const fetchDataAsync1 = async () => {
        try {
            const payload = { uid: uid };
            const apiname = SUPRIVISOR_API.sdoctordata;
            const response = await LoginService.getData(apiname, payload);
            setFirstName(response[0].firstName);
            setLastname(response[0].lastName);
            setEmail(response[0].email);
            setPhone(response[0].phone);
            setCountry(response[0].country);
            setState(response[0].state);
            setCity(response[0].city);
            setAddress(response[0].address);
            setHospitalname(response[0].hospitalName)
            setprefix(response[0].hospitalPrefix)
            sethphone(response[0].hphone)
            sethcountry(response[0].hcountry)
            sethstate(response[0].hstate)
            sethcity(response[0].hcity)
            sethpin(response[0].hpin);
            sethaddress(response[0].haddress);
            sethsptl(response[0].hsptl)
            // setHospitalID(response[0].hsptl)


            const country = response[0].country;
            if (country && country.length > 0) {
                fetchstate(country);
                getcountryvalue(country);
            }
            const hcountry = response[0].hcountry;
            if (hcountry && country.length > 0) {
                gethcountryvalue(hcountry);
            }




        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //add document
    const [Adddocument, setAdddocument] = useState(false);
    const close = () => {
        setAdddocument(false);
    }


    const [doctorcount, setDoctorCount] = useState(0);
    const [assistantcount, setAssistantCount] = useState(0);
    const [casesCount, setCasesCount] = useState(0);
    console.log("doctorCount", doctorcount);
    //get country state
    const countrydata = useSelector((state: RootState) => state.sprofile.country);
    const statedata = useSelector((state: RootState) => state.sprofile.state);
    const name = useSelector((state: RootState) => state.sprofile.name);
    const hcountryname = useSelector((state: RootState) => state.sprofile.hcountry);



    useEffectOnce(() => {
        const fetchcountry = async () => {
            try {
                await dispatch(getCountry() as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchcountry();
    }, [dispatch]);





    const getcountryvalue = async (country: any) => {
        try {
            await dispatch(getcountryname(country) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const gethcountryvalue = async (hcountry: any) => {
        try {
            await dispatch(gethcountryname(hcountry) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }



    const fetchstate = async (country: any) => {
        try {
            await dispatch(getState(country) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const fetchAssistantcount = async () => {
        try {
            const payload = { userid: uid, q: 2 };
            const apiname = SUPRIVISOR_API.scount;
            const response = await LoginService.getData(apiname, payload);
            setAssistantCount(response)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchCasesCount = async () => {
        try {
            const payload = { userid: uid, q: 4 };
            const apiname = SUPRIVISOR_API.scount;
            const response = await LoginService.getData(apiname, payload);
            setCasesCount(response)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDoctorsCount = async () => {
        try {
            const payload = { userid: uid, q: 1 };
            const apiname = SUPRIVISOR_API.scount;
            const response = await LoginService.getData(apiname, payload);
            setDoctorCount(response)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffectOnce(() => {
        fetchDataAsync1();
        fetchDoctorsCount();
        fetchAssistantcount();
        fetchCasesCount();
    }, [dispatch]);
    const navigate = useNavigate();
    const viewPage1 = () => {
        const url = `/viewdocuments`;
        navigate(url);
    };


    const getAddressData = async () => {
        try {
            const payload = { address: address, uid: uid, q: 1 };
            const apiname = SUPRIVISOR_API.verifyadd;
            const data = await LoginService.getData(apiname, payload);

            if (data) {
                setAddress(data);
                //toast.current.show({ severity: 'success', summary: 'Verified Successfully', details: verify, life: 3000 });
            } else {
                setAddress('')
                console.warn('Invalid or empty response:', data);
            }
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    const toast = useRef<Toast>(null);

    //update profile 
    const updateProfilePersonal = async () => {
        // if (phoneError|| error) {
        //     if (toast.current) {
        //         toast.current.show({ severity: 'error', detail: 'Please enter all fields.' });
        //     }
        //     return;
        // }
        try {
            const payload = { phone: phone, address: address, city: city, country: country, state: state, hphone: hphone, haddress: haddress, hcity: hcity, hcountry: hcountry, hstate: hstate, hpin: pincode, hsptl: hsptl };
            const apiname = SUPRIVISOR_API.updateprofile;
            const data = await LoginService.getData(apiname, payload);
            if (toast.current) {
                toast.current.show({ severity: 'success', detail: data });
            }
            fetchDataAsync();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    const toast1 = useRef<Toast>(null);

    const ApplyProfile = async () => {
        try {
            const payload = { phone: phone, address: address, city: city, country: country, state: state, email: email, hospitalName: hospitalName, name: firstName, lname: lastName, pincode: pincode, uid: uid };
            const apiname = SUPRIVISOR_API.applyprofile;
            const data = await LoginService.getData(apiname, payload);
            if (toast1.current) {
                toast1.current.show({ severity: 'success', detail: data });
            }
            fetchDataAsync();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (e: any) => {
        setIsChecked(e.target.checked);
    };

    const phoneError = {
        required: phone.trim() === '',
        invalid: !/^\d{10}$/.test(phone.trim()) && phone.trim() !== '',
    };


    const cityError = {
        required: city.trim() === '',
        invalid: city.trim() !== '' && !/^[A-Za-z\s]+$/.test(city.trim()),
    };

    const errorStyle = {
        color: 'white',
        fontWeight: '400',
        backgroundColor: '#dc3545',
        padding: '8px 10px',
        marginTop: '5px',
        borderRadius: '4px',
        width: '100%',
        maxWidth: '610px',
        fontSize: '0.875rem',
    };
    const [inputValue, setInputValue] = useState('');
    const [error, setError] = useState('');

    const handleCityInputChange = (e: any) => {
        const value = e.target.value;
        setCity(value);

        // Validate if the input is not empty
        if (!value.trim()) {
            setError('This field is required.');
        } else {
            setError('');
        }
    };

    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/sup-profile.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    }
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <div className="col-16" style={{ textAlign: "right" }}>
                            <a
                                title="help"
                                onClick={(e) => openWindow(e, IUrl)}
                                style={{

                                    color: "blue",
                                    fontSize: 15, cursor: "pointer"
                                }}
                            >Help for this Page &nbsp;
                                <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                            </a>
                        </div>
                        <section className="content">
                            <div className="grid">

                                {data.map((response: any) =>
                                    <div className="col-3">
                                        <Card header="" style={{ width: '300px', borderTop: '2px solid blue', marginTop: '74px' }}>
                                            <div
                                                className="widget-user-header bg-info"
                                                style={{ borderRadius: '10px 10px 0 0', position: 'relative', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>

                                                <img
                                                    src={response.photo}
                                                    alt="User Avatar"
                                                    style={{
                                                        width: '110px',
                                                        height: '90px',
                                                        borderRadius: '50%',
                                                        position: 'absolute',
                                                        bottom: '-65px',
                                                        left: '50%',
                                                        padding: '3px',
                                                        backgroundColor: '#fff',
                                                        transform: 'translateX(-50%)',
                                                        border: '3px solid #adb5bd',

                                                    }}
                                                />
                                            </div>
                                            <h3
                                                className="widget-user-username"
                                                style={{
                                                    color: 'black',
                                                    fontSize: '25px',
                                                    fontWeight: '300',
                                                    marginTop: '70px'
                                                }}
                                            >
                                                {response.firstName}
                                            </h3>
                                            <h4
                                                className="widget-user-username"
                                                style={{
                                                    color: '#6c757d',
                                                    fontSize: '20px',
                                                    fontWeight: '300',
                                                    marginBottom: '20px',
                                                    marginTop: '10px'
                                                }}
                                            >
                                                Suprivisor
                                            </h4>
                                            <FileUpload mode="basic" id="fileToUpload" name="fileToUpload" customUpload accept="image/*" maxFileSize={1000000} uploadHandler={UploadManagerImage} auto />
                                            {selectedFile && <p style={{ marginTop: '10px' }}>{selectedFile.name}</p>}



                                        </Card>
                                        <Card header="" style={{ width: '300px', marginTop: '20px' }}>
                                            <div
                                                className="widget-user-header bg-info"
                                                style={{
                                                    height: '120px',
                                                    backgroundColor: 'rgb(255, 193, 7)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    width: '116%',
                                                    marginLeft: '-21px',
                                                    marginTop: '-40px',
                                                    borderTopLeftRadius: '3px',
                                                    borderTopRightRadius: '3px',
                                                }}
                                            >
                                                <img
                                                    src={response.logo}
                                                    alt="User Avatar"
                                                    style={{
                                                        width: '110px',
                                                        height: '80px',
                                                        borderRadius: '50%',
                                                        padding: '3px',
                                                        backgroundColor: 'rgb(255, 193, 7)',
                                                        marginRight: '15px',
                                                        marginLeft: '20px',
                                                        border: '3px solid #adb5bd',
                                                    }}
                                                />
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <h2
                                                        className="widget-user-username"
                                                        style={{
                                                            color: 'black',
                                                            fontWeight: '200',
                                                            fontSize: '25px',
                                                            marginBottom: '10px',
                                                        }}
                                                    >
                                                        {response.hospitalName}
                                                    </h2>
                                                    <h3
                                                        className="widget-user-username"
                                                        style={{
                                                            color: '#6c757d',
                                                            fontSize: '1rem',
                                                            margin: '0',
                                                            fontWeight: '400',
                                                        }}
                                                    >
                                                        Hospital Info
                                                    </h3>
                                                </div>
                                            </div>

                                            {[
                                                { label: 'Hospital Name', value: response.hospitalName, bgColor: 'rgb(0, 123, 255)' },
                                                { label: 'Doctors', value: doctorcount, bgColor: 'rgb(23, 162, 184)' },
                                                { label: 'Assistants', value: assistantcount, bgColor: 'rgb(40, 167, 69)' },
                                                { label: 'Cases', value: casesCount, bgColor: 'rgb(40, 167, 69)' },
                                            ].map((item, index) => (
                                                <React.Fragment key={index}>
                                                    <div
                                                        className="grid"
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            marginTop: '0px',
                                                        }}
                                                    >
                                                        <strong
                                                            style={{
                                                                width: '150px',
                                                                fontWeight: '500',
                                                                textAlign: 'left', marginLeft: '20px',
                                                                marginTop: '-5px',
                                                            }}
                                                        >
                                                            {item.label}
                                                        </strong>
                                                        <p
                                                            className="text-muted"
                                                            style={{
                                                                backgroundColor: item.bgColor,
                                                                color: 'white',
                                                                borderRadius: '6px',
                                                                textAlign: 'center',
                                                                marginLeft: '15px',
                                                                padding: '5px 10px',
                                                                display: 'inline-block',
                                                            }}
                                                        >
                                                            {item.value}
                                                        </p>
                                                    </div>
                                                    {index < 3 && (
                                                        <hr
                                                            style={{
                                                                width: '116%',
                                                                border: '0.5px solid rgba(0, 0, 0, 0.1)',
                                                                margin: '-8px 0',
                                                                marginLeft: '-20px'
                                                            }}
                                                        />
                                                    )}
                                                </React.Fragment>
                                            ))}

                                            <FileUpload
                                                mode="basic"
                                                id="fileToUpload"
                                                name="fileToUpload"
                                                customUpload
                                                accept="image/*"
                                                maxFileSize={1000000}
                                                style={{ marginTop: '10px' }}
                                                uploadHandler={UploadManagerHosImage}
                                                auto
                                            />
                                            {selectedFile1 && <p style={{ marginTop: '10px' }}>{selectedFile1.name}</p>}
                                        </Card>



                                    </div>
                                )}
                                <div className='col-6' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <div className='col-12' >
                                        <SelectButton value={value} onChange={(e) => setValue(e.value)} options={options} allowEmpty={false} />
                                    </div>
                                </div >
                                <div className='col-3' >
                                    <div style={{ marginTop: '40px', marginLeft: '-565px' }}>
                                        <div className='col-2'></div>
                                        <div className='col-2'></div>
                                        {value == 'Personal Info' && (
                                            <div>
                                                <Card className="profile-header" style={{ width: '850px' }}>
                                                    <Panel header="Personal Info" toggleable>
                                                        <div style={{ width: '100%' }}>
                                                            <h1 style={{ textAlign: 'left', marginTop: '-10px', width: '100%', marginLeft: '20px' }}>
                                                                Supervisor (*{data[0]?.status}*)
                                                            </h1>
                                                        </div>
                                                        <div className="grid">
                                                            <div className="col-12">


                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>FirstName:</label>
                                                                    <InputText id="nameoforg" type="text" placeholder="Enter Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                                                                </div>
                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>LastName:</label>
                                                                    <InputText id="nameoforg" type="text" placeholder="Enter Name" value={lastName} onChange={(e) => setLastname(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                                                                </div>

                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="email" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>E-Mail:</label>
                                                                    <InputText id="email" type="text" disabled placeholder="Enter E-mail" value={email} onChange={(e) => setEmail(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                                                                </div>

                                                                <div className="flex align-items-start mb-3">
                                                                    <label htmlFor="phone" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Phone Number:</label>
                                                                    <div style={{ flex: 1, marginLeft: '10px' }}>
                                                                        <InputText
                                                                            id="phone"
                                                                            type="number"
                                                                            placeholder="Enter Phone Number"
                                                                            value={phone}
                                                                            onChange={(e) => {
                                                                                const value = e.target.value;
                                                                                if (/^\d{0,10}$/.test(value)) {
                                                                                    setPhone(value);
                                                                                }
                                                                            }}
                                                                            style={{ width: '100%' }}
                                                                        />
                                                                        {phoneError.invalid && (
                                                                            <div style={errorStyle}>
                                                                                Invalid phone number: Must be exactly 10 digits
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="address" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Country:</label>

                                                                    <Dropdown id="country" value={country} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => { fetchstate(e.value); setCountry(e.value) }} options={countrydata} optionLabel="name" optionValue="id" placeholder="Select a Country" style={{ flex: 1, marginLeft: '10px' }} />
                                                                </div>

                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="zip" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>State:</label>
                                                                    <Dropdown id="country" value={state} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => setState(e.value)} options={statedata} optionLabel="name" optionValue="id" placeholder="Select a State" style={{ flex: 1, marginLeft: '10px' }} />
                                                                </div>

                                                                {/* <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="country" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>City:</label>
                                                                    <InputText id="phone" type="text" placeholder="Enter City" value={city} onChange={(e) => setCity(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                                                                    {cityError.invalid && (
                                                                        <div
                                                                            style={errorStyle}
                                                                        >
                                                                            City is required
                                                                        </div>
                                                                    )}
                                                                </div> */}
                                                                <div className="flex align-items-start mb-3">
                                                                    <label htmlFor="city" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>City:</label>
                                                                    <div style={{ flex: 1, marginLeft: '10px' }}>
                                                                        <InputText
                                                                            id="city"
                                                                            type="text"
                                                                            placeholder="Enter City"
                                                                            value={city}
                                                                            onChange={handleCityInputChange}
                                                                            style={{ width: '100%' }}
                                                                        />
                                                                        {error && <p style={errorStyle}>{error}</p>}

                                                                    </div>
                                                                </div>


                                                                <div className="flex align-items-center mb-3">
                                                                    <label htmlFor="state" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Address:</label>
                                                                    <InputText id="phone" type="text" placeholder="Enter Address" value={address} onChange={(e) => setAddress(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                                                                    {/* <i className="pi pi-map-marker" onClick={getAddressData} style={{ fontSize: '2em', cursor: 'pointer' }}></i> */}
                                                                </div>
                                                                {data[0]?.status === 'REGISTERED' && (
                                                                    <div className="p-field-checkbox">
                                                                        <input type="checkbox" id="remember" checked={isChecked} onChange={handleCheckboxChange} style={{ marginRight: '10px' }} />
                                                                        <label htmlFor="terms" className="p-checkbox-label">
                                                                            I agree to the Terms & Conditions
                                                                        </label>
                                                                    </div>
                                                                )}

                                                            </div>
                                                            <div className="card-footer">
                                                                <div className="flex justify-content-end" style={{ marginLeft: '150px' }}>
                                                                    {data[0]?.status === 'REGISTERED' ? (
                                                                        <Button label="Apply" className="p-button-info mr-2" onClick={ApplyProfile} style={{ backgroundColor: '#2563eb' }} />) : (
                                                                        <div style={{ width: '100px' }} className="mr-2"></div>)}
                                                                    <Button label="Uploads" className="p-button-info mr-2" onClick={viewPage1} style={{ backgroundColor: '#2563eb' }} />
                                                                    <Button label="Update" className="p-button-primary" onClick={updateProfilePersonal} style={{ backgroundColor: '#2563eb' }} />
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </Panel>
                                                </Card>
                                            </div>
                                        )}
                                    </div>
                                    <div style={{ display: 'flex', marginLeft: '-565px' }}>

                                        {value == 'Hospital Info' && (
                                            <div>
                                                <Card className="profile-header" style={{ width: '850px' }}>
                                                    <div className="grid">
                                                        <div className="col-12">


                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>HospitalName:</label>
                                                                <InputText id="nameoforg" type="text" placeholder="Enter Name" value={hospitalName} onChange={(e) => setHospitalname(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                                                            </div>
                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="nameoforg" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Hospital Prefix:</label>
                                                                <InputText id="nameoforg" type="text" placeholder="Enter Name" value={hospitalPrefix} onChange={(e) => setprefix(e.target.value)} style={{ flex: 1, marginLeft: '10px', width: '35vw' }} disabled />
                                                            </div>

                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="email" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>E-Mail:</label>
                                                                <InputText id="email" type="text" disabled placeholder="Enter E-mail" value={email} onChange={(e) => setEmail(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                                                            </div>

                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="phone" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Phone Number:</label>
                                                                <InputText id="phone" type="number" placeholder="Enter Phone Number" value={hphone} onChange={(e) => { const value = e.target.value; if (/^\d{0,10}$/.test(value)) { sethphone(value); } }} style={{ flex: 1, marginLeft: '10px' }} />

                                                            </div>

                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="address" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Country:</label>

                                                                <Dropdown id="country" value={hcountry} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => { fetchstate(e.value); sethcountry(e.value) }} options={countrydata} optionLabel="name" optionValue="id" placeholder="Select a Country" style={{ flex: 1, marginLeft: '10px' }} />
                                                            </div>

                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="zip" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>State:</label>
                                                                <Dropdown id="country" value={hstate} className="custom-dropdown-placeholder" onChange={(e: DropdownChangeEvent) => sethstate(e.value)} options={statedata} optionLabel="name" optionValue="id" placeholder="Select a State" style={{ flex: 1, marginLeft: '10px' }} />
                                                            </div>

                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="country" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>City:</label>
                                                                <InputText id="phone" type="text" placeholder="Enter City" value={hcity} onChange={(e) => sethcity(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                                                            </div>

                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="state" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Address:</label>
                                                                <InputText id="phone" type="text" placeholder="Enter Address" value={haddress} onChange={(e) => sethaddress(e.target.value)} style={{ flex: 1, marginLeft: '10px' }} />
                                                            </div>
                                                            <div className="flex align-items-center mb-3">
                                                                <label htmlFor="state" className="text-900 font-medium" style={{ width: '150px', textAlign: 'right', paddingRight: '20px' }}>Pincode:</label>
                                                                <InputText id="phone" type="text" placeholder="Enter pincode" value={pincode} onChange={(e) => { const newValue = e.target.value; if (/^\d{0,6}$/.test(newValue)) { sethpin(newValue); } }} style={{ flex: 1, marginLeft: '10px' }} />
                                                            </div>
                                                        </div>



                                                        <div className="col-12 card-footer">
                                                            <Button label="Submit" className="p-button-primary" onClick={updateProfilePersonal} />


                                                        </div>

                                                    </div>
                                                </Card>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </section>
                    </div>
                </div>
                <Toast ref={toast} ></Toast>
                <Toast ref={toast1} ></Toast>
            </div>
        </div>

    )
}
